import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { ClaimCountsDetailParams, DomainListClaimCountsResponse } from '@/Swagger';
import { queryKeys } from '@/app/queryKeys';
import axiosInstance from '@/axios/axios';

export type ClaimCountsRequest = Omit<ClaimCountsDetailParams, 'shopId'>;

async function getClaimCounts(shopID: string, request?: ClaimCountsRequest) {
  return axiosInstance
    .get<DomainListClaimCountsResponse>(`/shops/${shopID}/claim-counts`, {
      params: { ...request },
    })
    .then(v => v.data);
}

/**
 * 클레임 카운트를 조회하는 API 입니다.
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Claims/get_shops__shopID__claim_counts
 */
export default function useGetClaimsCounts(
  shopID: string,
  request: ClaimCountsRequest,
  option?: Partial<
    UseQueryOptions<
      DomainListClaimCountsResponse,
      AxiosError,
      DomainListClaimCountsResponse,
      [string, string, { shopID: string; request: ClaimCountsRequest }]
    >
  >,
) {
  return useQuery({
    queryKey: queryKeys.claimCountsByShopID(shopID, request),
    queryFn: () => getClaimCounts(shopID, request),
    enabled: !!shopID,
    ...option,
  });
}
